import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css"

// import * as serviceWorker from "./serviceWorker";
import App from "./app/App";

// third party style
import "perfect-scrollbar/css/perfect-scrollbar.css";

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
  {/* <QueryClientProvider client={queryClient}> */}
     <App />
  {/* </QueryClientProvider> */}
  </BrowserRouter>
);

// for IE-11 support un-comment cssVars() and it's import in this file
// and in MatxTheme file

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// "@material-ui/core": "^4.12.4",
//     "@material-ui/icons": "^4.11.3",
//     "@mui/icons-material": "^5.15.10",
//     "@mui/lab": "^5.0.0-alpha.165",
//     "@mui/material": "^5.16.7",
//     "@mui/styles": "^5.15.19",
//     "@mui/x-data-grid": "^7.15.0",
//     "@mui/x-data-grid-generator": "^7.17.0",
// "@mui/x-date-pickers": "^7.21.0",

// "ajv": "^8.17.1",
//     "ajv-keywords": "^5.1.0",
